
export default function LatestTaskItem(props) {
    return (
        <div className="flex justify-between items-center py-6 border-b first-of-type:pt-0 first-of-type:pb-[29px]">
            <div className="flex flex-col gap-1">
                <h4 className="font-bold">{props.title}</h4>
                <p className="text-sm text-gray-500">{props.subtitle}</p>
            </div>
            <i className="hover:text-red-600 hover:cursor-pointer">{props.icon}</i>
        </div>
    )
}
